// extracted by css-extract-rspack-plugin
export default {"outer":"LeadingVisual-module__outer__SRqB8","inner":"LeadingVisual-module__inner__qoAw2"};